<template>
  <a-form :form="form" @submit.prevent="handleConfigInfoSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="30">
      <!-- 待机设置 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.standbyTitle')}}</h3>
        <!-- 进入待机时间 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.screenTimeout')" >
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.screenTimeoutTxt')"
              v-decorator="['enterStandbyTime',{
                  initialValue: deviceConfig.enterStandbyTime, 
                  rules: [{ 
                    required: true, 
                    message: $t('devicesManaConfig.terminal.screenTimeoutBlank') 
                  }] 
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_30s')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.option_1m')}}</a-select-option>
              <a-select-option value="3">{{$t('devicesManaConfig.terminal.option_5m')}}</a-select-option>
              <a-select-option value="4">{{$t('devicesManaConfig.terminal.option_10m')}}</a-select-option>
              <a-select-option value="5">{{$t('devicesManaConfig.terminal.option_30m')}}</a-select-option>
              <a-select-option value="99">{{$t('devicesManaConfig.terminal.option_Non')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 待机状态表现 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.standbyMode')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.standbyModeTxt')"
              v-decorator="['standbyModePerformance',{
                  initialValue: deviceConfig.standbyModePerformance, 
                  rules: [{ 
                    required: true, 
                    message: $t('devicesManaConfig.terminal.standbyModeBlank') 
                  }] 
                }
              ]"
              @change="handleStandbyModeChange"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_display')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.option_defaultVideo')}}</a-select-option>
              <a-select-option value="3">{{$t('devicesManaConfig.terminal.option_customPictures')}}</a-select-option>
              <a-select-option value="4">{{$t('devicesManaConfig.terminal.option_customVideo')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 上传待机图片 -->
        <a-col :span="8" v-if="standbyImageVisible">
          <a-form-item :label="$t('devicesManaConfig.terminal.standbyImage')">
            <a-upload
              accept="image/jpeg,image/jpg,image/png"
              listType="picture"
              :beforeUpload="handleBeforeUploadStandbyImage"
              v-decorator="[
                'standbyImage',
                {
                  valuePropName: 'fileList',
                  getValueFromEvent: handleStandbyImageChange,
                  rules: [{ required: standbyImageVisible, message: $t('devicesManaConfig.terminal.standbyImageBlank') }] 
                },
              ]"
            >
              <a-button> <a-icon :type="standbyImageUploading?'loading':'upload'" /> {{$t('devicesManaConfig.terminal.uploadImageBtn')}} </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- 上传待机视频  -->
        <a-col :span="8" v-if="standbyVideoVisible">
          <a-form-item :label="$t('devicesManaConfig.terminal.standbyVideo')">
            <a-upload
              accept="video/mp4"
              :beforeUpload="handleBeforeUploadStandbyVideo"
              v-decorator="[
                'standbyVideo',
                {
                  valuePropName: 'fileList',
                  getValueFromEvent: handleStandbyVideoChange,
                  rules: [{ required: standbyVideoVisible, message: $t('devicesManaConfig.terminal.standbyVideoBlank') }] 
                },
              ]"
            >
              <a-button> <a-icon :type="standbyVideoUploading?'loading':'upload'" /> {{$t('devicesManaConfig.terminal.uploadVideoBtn')}} </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- 待机亮度类型 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.standbyBrightnessType')">
            <a-select
              :disabled="isStandbyScreenOff"
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.standbyBrightnessTypeTxt')"
              v-decorator="[
                'standbyBrightnessType',
                {
                  initialValue: deviceConfig.standbyBrightnessType, 
                  rules: [{ 
                    required: !isStandbyScreenOff, 
                    message: $t('devicesManaConfig.terminal.standbyBrightnessTypeBlank') 
                  }] 
                }
              ]"
              @change="handleChangeStandbyBrightnessType"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_followSystem')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.option_userDefined')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 待机亮度 -->
        <a-col :span="8" v-if="brightnessBySelf && !isStandbyScreenOff">
          <a-form-item :label="$t('devicesManaConfig.terminal.standbyBrightness')">
            <a-col :span="14">
              <a-slider 
                :disabled="isStandbyScreenOff"
                :min="1" 
                :max="100"
                :marks="{0: '0', 100: '100'}"
                @change="value => inputBrightnessValue = value"
                v-decorator="[
                  'standbyBrightnessValue',
                  { 
                    initialValue: deviceConfig.standbyBrightnessValue || 30,
                    rules: [{ 
                      required: brightnessBySelf && !isStandbyScreenOff,
                      message: $t('devicesManaConfig.terminal.standbyBrightnessBlank')
                    }] 
                  }
                ]"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                :disabled="isStandbyScreenOff"
                :min="1" 
                :max="100"
                style="marginLeft: 22px;width:70px"
                @change="value => form.setFieldsValue({standbyBrightnessValue: value})"
                v-model="inputBrightnessValue"
              />
            </a-col>
          </a-form-item>
        </a-col>
      </a-col>
      
      <!-- 时间与日期 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.dateAndTimeTitle')}}</h3>
        <!-- 是否显示时间与日期 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.showDateAndTime')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.showDateAndTimeTxt')"
              v-decorator="['showDateTime',{ 
                  initialValue: deviceConfig.showDateTime || '1',
                  rules: [{ 
                    required: true, 
                    message: $t('devicesManaConfig.terminal.showDateAndTimeBlank')
                  }] 
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 同步方式 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.syncWay')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.syncWayTxt')"
              v-decorator="['syncMode',{ 
                  initialValue: deviceConfig.syncMode || '1',
                  rules: [{ 
                    required: true, 
                    message: $t('devicesManaConfig.terminal.syncWayBlank')
                  }] 
                }
              ]"
              @change="handleChangeSyncMode"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_serverSync')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.option_manualSettings')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 自定义时间与日期 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.setDateAndTime')">
            <a-date-picker
              dropdownClassName="form-date-picker"
              :getCalendarContainer="trigger => trigger.parentNode"
              style="width: 100%"
              showTime
              :placeholder="$t('devicesManaConfig.terminal.setDateAndTimeTxt')"
              :disabled="!sysDateTimeBySelf"
              v-decorator="['sysDateTime',{ 
                  initialValue: moment(deviceConfig.sysDateTime || new Date()),
                  rules: [{ 
                    required: sysDateTimeBySelf,
                    message: $t('devicesManaConfig.terminal.setDateAndTimeBlank')
                  }] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 日期显示格式 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.dateFormat')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.dateFormatTxt')"
              v-decorator="['dateDisplayFormat',{ 
                  initialValue: deviceConfig.dateDisplayFormat || 'YYYY年MM月DD日',
                  rules: [{ 
                    required: true,
                    message: $t('devicesManaConfig.terminal.dateFormatTBlank')
                  }] 
                }
              ]"
            >
              <a-select-option value="YYYY年MM月DD日">YYYY年MM月DD日</a-select-option>
              <a-select-option value="YYYY-MM-DD">YYYY-MM-DD</a-select-option>
              <a-select-option value="MM月DD日YYYY年">MM月DD日YYYY年</a-select-option>
              <a-select-option value="MM-DD-YYYY">MM-DD-YYYY</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 时间显示格式 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.timeFormat')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.timeFormatTxt')"
              v-decorator="['timeDisplayFormat',{ 
                  initialValue: deviceConfig.timeDisplayFormat || '24小时制',
                  rules: [{ 
                    required: true,
                    message: $t('devicesManaConfig.terminal.timeFormatBlank')
                  }] 
                }
              ]"
            >
              <a-select-option value="12小时制">{{$t('devicesManaConfig.terminal.option_12h')}}</a-select-option>
              <a-select-option value="24小时制">{{$t('devicesManaConfig.terminal.option_24h')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 公司信息 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.companyInfoTitle')}}</h3>
        <!-- 是否显示公司信息 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.showCompanyInfo')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.showCompanyInfoTxt')"
              v-decorator="['displayCompanyInfo',{
                  initialValue: deviceConfig.displayCompanyInfo || '1',
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.showCompanyInfoWarning')
                  }]
                }
              ]"
              @change="handleChangeEnableDisplayCompanyInfo"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 公司名称 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.companyName')">
            <a-input
              :disabled="!companyInfoVisible"
              :placeholder="$t('devicesManaConfig.terminal.companyNameTxt')"
              v-decorator="[
                'companyName',
                { 
                  initialValue: deviceConfig.companyName || '',
                  rules: [
                    { required: companyInfoVisible, message: $t('devicesManaConfig.terminal.companyNameBlank') },
                    { max: 40, message: $t('devicesManaConfig.terminal.companyNameWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 公司LOGO -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.companyLogo')">
            <a-upload
              :disabled="!companyInfoVisible"
              accept="image/jpeg,image/jpg,image/png"
              listType="picture"
              :beforeUpload="handleBeforeUploadLogo"
              v-decorator="[
                'companyLogo',
                {
                  valuePropName: 'fileList',
                  getValueFromEvent: handleCompanyLogoChange,
                  rules: [{ required: companyInfoVisible, message: $t('devicesManaConfig.terminal.companyLogoBlank') }] 
                },
              ]"
            >
              <a-button :disabled="!companyInfoVisible"> 
                <a-icon :type="companyLogoUploading?'loading':'upload'" /> 
                {{$t('devicesManaConfig.terminal.uploadLogoBtn')}} 
              </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 语言设置 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.settingLanguage')}}</h3>
        <!-- 语言设置 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.settingLanguage')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.settingLanguageTxt')"
              v-decorator="['language',{
                  initialValue: deviceConfig.language || '1',
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.settingLanguageWarning')
                  }]
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_cn')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.option_us')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 语音播报 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.voiceBroadcastTitle')}}</h3>
        <!-- 是否启用语音播报 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.enableVoiceBroadcast')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.enableVoiceBroadcastTxt')"
              v-decorator="['enableVoiceBroadcast',{
                  initialValue: deviceConfig.enableVoiceBroadcast || '1', 
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.enableVoiceBroadcastBlank')
                  }]
                }
              ]"
              @change="handleChangeEnableVoiceBroadcast"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 门禁卡识别成功语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.S_cardRecogVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.S_cardRecogVoiceTxt')"
              v-decorator="[
                'iccardRecogSuccBroadcast',
                { 
                  initialValue: deviceConfig.iccardRecogSuccBroadcast || $t('devicesManaConfig.terminal.S_cardRecogVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.S_cardRecogVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.S_cardRecogVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 门禁卡识别失败语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.F_cardRecogVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.F_cardRecogVoiceTxt')"
              v-decorator="[
                'iccardRecogFailBroadcast',
                { 
                  initialValue: deviceConfig.iccardRecogFailBroadcast || $t('devicesManaConfig.terminal.F_cardRecogVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.F_cardRecogVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.F_cardRecogVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 人脸识别中语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.faceRecogVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.faceRecogVoiceTxt')"
              v-decorator="[
                'faceRecogingBroadcast',
                { 
                  initialValue: deviceConfig.faceRecogingBroadcast || $t('devicesManaConfig.terminal.faceRecogVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.faceRecogVoiceBlank') },
                    { max: 20,message: $t('devicesManaConfig.terminal.faceRecogVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 人脸识别成功语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.S_faceRecogVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.S_faceRecogVoiceTxt')"
              v-decorator="[
                'faceRecogSuccBroadcas',
                { 
                  initialValue: deviceConfig.faceRecogSuccBroadcas || $t('devicesManaConfig.terminal.S_faceRecogVoiceDefault'),
                  rules: [
                    { required: false, message:  $t('devicesManaConfig.terminal.S_faceRecogVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.S_faceRecogVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 人脸识别失败语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.F_faceRecogVoice')">
            <a-input
              :placeholder="$t('devicesManaConfig.terminal.F_faceRecogVoiceTxt')"
              :disabled="true"
              v-decorator="[
                'faceRecogFailBroadcast',
                { 
                  initialValue: deviceConfig.faceRecogFailBroadcast || $t('devicesManaConfig.terminal.F_faceRecogVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.F_faceRecogVoiceBlank') },
                    { max: 20,message: $t('devicesManaConfig.terminal.F_faceRecogVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 未佩戴口罩语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.noMaskVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.noMaskVoiceTxt')"
              v-decorator="[
                'noMaskBroadcast',
                { 
                  initialValue: deviceConfig.noMaskBroadcast || $t('devicesManaConfig.terminal.noMaskVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.noMaskVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.noMaskVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 体温正常语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.normothermiaVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.normothermiaVoiceTxt')"
              v-decorator="[
                'tempRightBroadcast',
                { 
                  initialValue: deviceConfig.tempRightBroadcast || $t('devicesManaConfig.terminal.normothermiaVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.normothermiaVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.normothermiaVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 体温异常语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.abnormothermiaVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.abnormothermiaVoiceTxt')"
              v-decorator="[
                'tempAbnormalBroadcast',
                { 
                  initialValue: deviceConfig.tempAbnormalBroadcast || $t('devicesManaConfig.terminal.abnormothermiaVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.abnormothermiaVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.abnormothermiaVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- 开门时间范围外语音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.invalidTimeVoice')">
            <a-input
              :disabled="true"
              :placeholder="$t('devicesManaConfig.terminal.invalidTimeVoiceTxt')"
              v-decorator="[
                'invalidOpenTimeBroadcast',
                { 
                  initialValue: deviceConfig.invalidOpenTimeBroadcast || $t('devicesManaConfig.terminal.invalidTimeVoiceDefault'),
                  rules: [
                    { required: false, message: $t('devicesManaConfig.terminal.invalidTimeVoiceBlank') },
                    { max: 20, message: $t('devicesManaConfig.terminal.invalidTimeVoiceWarning') }
                  ] 
                }
              ]"
            />
          </a-form-item>
        </a-col>
      </a-col>

      <!-- 日志配置 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{$t('devicesManaConfig.terminal.logCnfigTitle')}}</h3>
        <!-- 是否保存设备工作日志 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.saveDeviceWorkLog')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.saveDeviceWorkLogTxt')"
              v-decorator="['saveDeviceWorkLog',{
                  initialValue: deviceConfig.saveDeviceWorkLog || '1', 
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.saveDeviceWorkLogBlank')
                  }]
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否保存用户操作日志 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.saveUserActionsLog')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.saveUserActionsLogTxt')"
              v-decorator="['saveUserActionsLog',{
                  initialValue: deviceConfig.saveUserActionsLog || '1', 
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.saveUserActionsLogBlank')
                  }]
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否保存设备报警日志 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.saveDeviceAlarmLog')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.terminal.saveDeviceAlarmLogTxt')"
              v-decorator="['saveDeviceAlarmLog',{
                  initialValue: deviceConfig.saveDeviceAlarmLog || '1', 
                  rules: [{
                    required: true,
                    message: $t('devicesManaConfig.terminal.saveDeviceAlarmLogBlank')
                  }]
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.terminal.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.terminal.options_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 日志保留天数 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.terminal.logRetentionDays')">
            <a-col :span="14">
              <a-slider 
                :min="1" 
                :max="180"
                :marks="{0: '0', 180: '180'}"
                @change="value => inputLogRetentionDays = value"
                v-decorator="[
                  'logRetentionDays',
                  { 
                    initialValue: deviceConfig.logRetentionDays || 30,
                    rules: [{ 
                      required: true,
                      message: $t('devicesManaConfig.terminal.logRetentionDaysBlank')
                    }] 
                  }
                ]"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                :disabled="isStandbyScreenOff"
                :min="1" 
                :max="180"
                style="marginLeft: 22px;width:70px"
                @change="value => form.setFieldsValue({logRetentionDays: value})"
                v-model="inputLogRetentionDays"
              />
            </a-col>
          </a-form-item>
        </a-col>
      </a-col>

      <a-col :span="24" style="margin-top: 16px; text-align: right">
        <a-button 
          type="primary" 
          html-type="submit" 
          :loading="submitting"
        >{{$t('devicesManaConfig.terminal.submitBtn')}}</a-button>
        <a-button 
          :style="{ marginLeft: '8px' }" 
          @click="$emit('backList') "
        >{{$t('devicesManaConfig.terminal.backBtn')}}</a-button>
      </a-col>
    </a-row>    
  </a-form>
</template>

<script>
import moment from 'moment';
import { compressImageFile } from '../../../utils/utils'
import { uploadFiles } from '../../../api/fileUpload'
import { mapState } from 'vuex';

export default {
  name: 'TerminalSettingForm',
  components: {},
  props: {
    deviceConfig: {
      type: Object,
      required: true,
      default: null
    },
    deviceId: {
      type: String,
      required: true,
      default: undefined
    }
  },
  data() {
    return {
      lastDeviceId: null,

      form: this.$form.createForm(this),

      isStandbyScreenOff: false, // 是否以息屏作为待机模式

      standbyVideoVisible: false, // 是否上传自定义待机视频
      standbyVideoUploading: false, // 是否在上传待机视频
      standbyVideo: [],

      standbyImageVisible: false, // 是否上传自定义待机图片
      standbyImageUploading: false, // 是否在上传待机图片
      standbyImage: [], // 待机图片

      brightnessBySelf: false, // 是否为自定义设置屏幕亮度
      inputBrightnessValue: 30,

      sysDateTimeBySelf: false, // 是否为自定义时间日期

      companyInfoVisible: true, // 是否显示公司信息
      companyLogoUploading: false, // 是否在上传公司logo
      companyLogo: [],

      voiceBroadcast: true, // 是否启用了语音播报

      inputLogRetentionDays: 30,

      submitting: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  created() {
    // console.log('--TerminaSettingForm created--', this.deviceConfig);
    // this.initConfig()
  },
  activated() {
    if (this.deviceId !== this.lastDeviceId) {
      this.lastDeviceId = this.deviceId 
      this.initConfig()
    }
  },
  methods: {
    moment,
    // 处理进入本类配置的数据
    initConfig() {
      this.$nextTick(() => {
        this.deviceConfig.sysDateTime = moment(this.deviceConfig.sysDateTime);
        if (this.deviceConfig.standbyImage) {
          this.standbyImage[0] = {
            uid: 'default-standbyImage',
            name: this.$t('devicesManaConfig.terminal.standbyImage'),
            status: 'done',
            thumbUrl: this.deviceConfig.standbyImage,
            url: this.deviceConfig.standbyImage
          };
          this.$nextTick(() => {
            this.form.setFieldsValue({ standbyImage: this.standbyImage })
          })
        }
        if (this.deviceConfig.standbyVideo) {
          this.standbyVideo[0] = {
            uid: 'default-standbyVideo',
            name: this.$t('devicesManaConfig.terminal.standbyVideo'),
            status: 'done',
            thumbUrl: this.deviceConfig.standbyVideo,
            url: this.deviceConfig.standbyVideo
          };
          this.$nextTick(() => {
            this.form.setFieldsValue({ standbyVideo: this.standbyVideo })
          })
        }
        if (this.deviceConfig.companyLogo) {
          this.companyLogo[0] = {
            uid: 'default-companyLogo',
            name: this.$t('devicesManaConfig.terminal.companyLogo'),
            status: 'done',
            thumbUrl: this.deviceConfig.companyLogo,
            url: this.deviceConfig.companyLogo
          };
          this.$nextTick(() => {
            this.form.setFieldsValue({ companyLogo: this.companyLogo })
          })
        }

        this.inputBrightnessValue = this.deviceConfig.standbyBrightnessValue || this.inputBrightnessValue;
        this.inputLogRetentionDays = this.deviceConfig.logRetentionDays || this.inputLogRetentionDays;

        this.isStandbyScreenOff = this.deviceConfig.standbyModePerformance === '1'
        this.standbyImageVisible = this.deviceConfig.standbyModePerformance === '3'
        this.standbyVideoVisible = this.deviceConfig.standbyModePerformance === '4'

        this.brightnessBySelf = this.deviceConfig.standbyBrightnessType === '2'
        this.sysDateTimeBySelf = this.deviceConfig.syncMode === '2'
        this.voiceBroadcast = this.deviceConfig.enableVoiceBroadcast !== '2'
        this.companyInfoVisible = this.deviceConfig.displayCompanyInfo !== '2'
      })
    },

    // 提交配置信息
    handleConfigInfoSubmit(e) {

      this.form.validateFields((err, values) => {
        // console.log(err, values)
        if (!err) {
          let config = Object.assign({}, values);

          const { standbyBrightnessValue, standbyImage, standbyVideo, companyLogo, sysDateTime } = config
          const dateTimeArr = sysDateTime.format('YYYY-MM-DD HH:mm:ss').split(' ');

          config.standbyBrightnessValue = standbyBrightnessValue ? String(standbyBrightnessValue) : null;
          config.standbyImage = standbyImage && standbyImage[0] ? standbyImage[0].thumbUrl : null;
          config.standbyVideo = standbyVideo && standbyVideo[0] ? standbyVideo[0].thumbUrl : null;
          config.companyLogo = companyLogo && companyLogo[0] ? companyLogo[0].thumbUrl : null;
          
          config.sysDate = dateTimeArr[0];
          config.sysTime = dateTimeArr[1];

          this.$emit('submitConfig', config)
        }
      })
    },

    // 待机状态改变时
    handleStandbyModeChange(value) {
      if (value === '1') {
        this.isStandbyScreenOff = true
        this.standbyImageVisible = false
        this.standbyVideoVisible = false
      } else {
        this.isStandbyScreenOff = false
        this.standbyImageVisible = false
        this.standbyVideoVisible = false
        this.$nextTick(() => {
          this.form.validateFields(['standbyBrightnessType', 'standbyBrightnessValue'], { force: true })
        })
        if (value === '3') {
          this.standbyImageVisible = true
          this.$nextTick(() => {
            this.form.setFieldsValue({ standbyImage: this.standbyImage })
            this.form.validateFields(['standbyImage'], { force: true })
          })
        }
        if (value === '4') {
          this.standbyVideoVisible = true
          this.$nextTick(() => {
            this.form.setFieldsValue({ standbyVideo: this.standbyVideo })
            this.form.validateFields(['standbyVideo'], { force: true })
          })
        }
      }
    },

    // 待机亮度类型改变时
    handleChangeStandbyBrightnessType(value) {
      let vm = this;
      if (value === '2') {
        this.brightnessBySelf = true;
        this.$nextTick(() => {
          this.form.validateFields(['standbyBrightnessValue'], { force: true });
        });
      } else {
        this.brightnessBySelf = false;
      }
    },

    // 上传待机图片前
    async handleBeforeUploadStandbyImage(file) {
      this.standbyImageUploading = true
      const res = await this.handleBeforeUploadImg(file)
      this.standbyImage[0] = res
      this.form.setFieldsValue({ standbyImage: this.standbyImage })
      this.standbyImageUploading = false

      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
    },
    // 上传待机图片
    handleStandbyImageChange(file) {
      // console.log('-handleStandbyImageChange-', file)
      if (file.file.status === 'removed') {
        this.standbyImage = []
      }
      return this.standbyImage;
    },

    // 上传待机图片前
    async handleBeforeUploadStandbyVideo(file) {
      // console.log('-handleBeforeUploadStandbyVideo-', file)
      if (file.size / 1024 < 5 * 1024) {
        this.standbyVideoUploading = true

        const formData = new FormData()
        formData.append('file', file)
        const { data } = await uploadFiles(formData)
        this.standbyVideo[0] = {
          uid: file.uid,
          name: file.name,
          size: file.size,
          status: 'done',
          thumbUrl: data.collection[0],
          url: data.collection[0]
        }
        this.form.setFieldsValue({ standbyVideo: this.standbyVideo })
        this.standbyVideoUploading = false
      } else {
        this.$notification.error({
          message: '视频文件大小不能超过 5M！',
          duration: 2.5
        })
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
    },
    // 上传待机图片
    handleStandbyVideoChange(file) {
      // console.log('-handleStandbyVideoChange-', file)
      if (file.file.status === 'removed') {
        this.standbyVideo = []
      }
      return this.standbyVideo;
    },

    // 是否显示公司信息改变时
    handleChangeEnableDisplayCompanyInfo(value) {
      if (value !== '2') {
        this.companyInfoVisible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue({ companyLogo: this.companyLogo })
          this.form.validateFields(
            [
              'companyLogo', 
              'companyName'
            ], 
            { force: true }
          );
        });
      } else {
        this.companyInfoVisible = false;
        this.form.setFieldsValue({ companyLogo: this.companyLogo })
        this.form.resetFields(
          [
            'companyLogo', 
            'companyName'
          ], 
          { force: true }
        );
      }
    },

    // 是否启用语音播报改变时
    handleChangeEnableVoiceBroadcast(value) {
      let vm = this;
      if (value !== '2') {
        this.voiceBroadcast = true;
        this.$nextTick(() => {
          this.form.validateFields(
            [
              'iccardRecogSuccBroadcast', 
              'iccardRecogFailBroadcast', 
              'faceRecogingBroadcast',
              'faceRecogSuccBroadcas',
              'noMaskBroadcast',
              'tempRightBroadcast',
              'tempAbnormalBroadcast',
              'invalidOpenTimeBroadcast'
            ], 
            { force: true }
          );
        });
      } else {
        this.voiceBroadcast = false;
      }
    },

    // 系统时间同步方式改变时
    handleChangeSyncMode(value) {
      let vm = this;
      if (value === '2') {
        this.sysDateTimeBySelf = true;
        this.$nextTick(() => {
          this.form.validateFields(['sysDateTime'], { force: true });
        });
      } else {
        this.sysDateTimeBySelf = false;
      }
    },

    // 上传公司LOGO前
    async handleBeforeUploadLogo(file) {
      this.companyLogoUploading = true
      const res = await this.handleBeforeUploadImg(file)
      this.companyLogo[0] = res
      this.form.setFieldsValue({ companyLogo: this.companyLogo })
      this.companyLogoUploading = false
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject()
    },
    // 上传公司LOGO
    handleCompanyLogoChange(file) {
      if (file.file.status === 'removed') {
        this.companyLogo = []
      }
      return this.companyLogo;
    },

    // 提交图片前，验证图片大小和宽高，不符合就进行图片压缩
    handleBeforeUploadImg(file) {
      return new Promise(resolve => {
        compressImageFile(file, { maxSize: 200 }, image => {
          resolve({
            uid: image.uid,
            name: image.name,
            status: 'done',
            thumbUrl: image.base64
          })
        })
      })
    }
  }    
}
</script>

<style scoped>
</style>